<form [formGroup]="configurationFormAs2">
  <div class="form-row row">
    <div class="form-group col-xl-4 col-lg-6">
      <label for="ic-as2From" class="control-label required">{{ 'i18n.domain.import-configuration.edit.as2.as2-from' | translate }}</label>
      <input id="ic-as2From" type="text" class="form-control" formControlName="as2From" />
      <app-error-messages [control]="configurationFormAs2.controls.as2From"></app-error-messages>
    </div>
    <div class="form-group col-xl-4 col-lg-6">
      <label for="ic-as2To" class="control-label required">{{ 'i18n.domain.import-configuration.edit.as2.as2-to' | translate }}</label>
      <input id="ic-as2To" type="text" class="form-control" formControlName="as2To" />
      <app-error-messages [control]="configurationFormAs2.controls.as2To"></app-error-messages>
    </div>
    <div class="form-group col-xl-4 col-lg-6">
      <label for="ic-useCompression" class="control-label required">{{ 'i18n.domain.import-configuration.edit.as2.use-compression' | translate }}</label>
      <app-yes-no-group-button id="ic-useCompression" formControlName="useCompression"></app-yes-no-group-button>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-xl-4 col-lg-6">
      <label for="ic-doSignMessages" class="control-label required">{{ 'i18n.domain.import-configuration.edit.as2.sign-message' | translate }}</label>
      <app-yes-no-group-button id="ic-doSignMessages" formControlName="doSignMessages"></app-yes-no-group-button>
    </div>
  </div>
  @if (configurationFormAs2.controls.doSignMessages.value === true) {
    <div class="form-row row">
      <div class="form-group col-xl-4 col-lg-6">
        <label for="ic-certificateMediaName" class="control-label required">{{ 'i18n.domain.import-configuration.edit.as2.sign-certificate' | translate }}</label>
        <input id="ic-certificateMediaName" type="text" class="form-control" formControlName="certificateMediaName"/>
        <app-error-messages [control]="configurationFormAs2.controls.certificateMediaName"></app-error-messages>
      </div>
      <div class="form-group col-xl-4 col-lg-6">
        <label for="ic-certificateMedia" class="control-label required">{{'i18n.domain.import-configuration.edit.as2.upload-certificate' | translate}}</label>
        <ejs-uploader #defaultupload
                      id="ic-certificateMedia"
                      allowedExtensions=".cer,.pfx,.ppk,.p7b,.p7c,.pem,.pub"
                      multiple="false"
                      [autoUpload]="false"
                      (removing)="onFileRemove()"
                      (selected)="handleFileInput($event)">
        </ejs-uploader>
      </div>
      <div class="form-group col-xl-4 col-lg-6">
        <label for="ic-certificatePassword" class="control-label">{{ 'i18n.domain.import-configuration.edit.as2.certificate-password' | translate }}</label>
        <input id="ic-certificatePassword" type="text" class="form-control" formControlName="certificatePassword" />
        <app-error-messages [control]="configurationFormAs2.controls.certificatePassword"></app-error-messages>
      </div>
    </div>
  }
</form>
